// import { STORE_VERSION } from "@fedsim/constants"

import { generateWinLossRecord } from 'contexts/Wrestler/model'

export const migrations = [
  {
    title: '10 to 10.2',
    description: 'Post release updates',
    groupNames: ["GAME"],
    sortOrder: 0,
    transform: (session) => {
      session.Game.all()
        .toModelArray()
        .forEach(item => {
          item.storeVersion = 210

          item.update()
        })

      return session
    }
  },
  // {
  //   title: '110 to 120',
  //   description: 'Add rank field to championships',
  //   groupNames: ["GAME", "WRESTLER"],
  //   sortOrder: 0,
  //   transform: (session) => {
  //     session.Game.all()
  //       .toModelArray()
  //       .forEach(item => {
  //         item.storeVersion = STORE_VERSION

  //         item.update()
  //       })
  //     session.Championship.all()
  //       .toModelArray()
  //       .forEach(item => {
  //         item.rank = 100

  //         item.update()
  //       })


  //     return session
  //   }
  // }
]
function pickRandomIdsFromArray(array) {
  const randomItems = []
  const randomLength = Math.floor(Math.random() * array.length)
  for (let i = 0; i < randomLength; i++) {
    const randomIndex = Math.floor(Math.random() * array.length)
    if (!randomItems.includes(array[randomIndex])) {
      randomItems.push(array[randomIndex])
    }
  }
  return randomItems
}
export const modifiers = [
  {
    title: 'Generate random win/loss record based on points',
    description: 'Generate random win/loss record based on points',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all().toModelArray().forEach(item => {
        const { wins, losses } = generateWinLossRecord(item)

        item.wins = Number(wins)
        item.losses = Number(losses)
        item.streak = 0

        item.update()
      })
    }
  },
  {
    title: 'Randomise everyones brands',
    description: 'Randomise everyones brands',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.brandIds = pickRandomIdsFromArray(session.Brand.all().toRefArray().map(item => item.id))

          item.update()
        })
    }
  },
  {
    title: 'Reset Birthdays',
    description: 'Reset all Wrestler date of births',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.dob = null

          item.update()
        })

      return session
    }
  },
  {
    title: 'Reset Win/Loss',
    description: 'Reset all Wrestler wins/losses/streaks',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.wins = 0
          item.losses = 0
          item.streaks = 0

          item.update()
        })

      return session
    }
  },
  {
    title: 'Reset Injuries',
    description: 'Reset all damage and set all active',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.active = true
          item.damage = 0

          item.update()
        })

      return session
    }
  }
]
